import { render, staticRenderFns } from "./SellPriceCategoryMultiSelect.vue?vue&type=template&id=01cc1f72"
import script from "./SellPriceCategoryMultiSelect.vue?vue&type=script&lang=ts"
export * from "./SellPriceCategoryMultiSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports